import { Router } from 'vue-router'

import {
  createPopup,
  EXTENSION_HEIGHT_PX,
  POPUP_BAR_HEIGHT_PX,
  POPUP_BAR_HEIGHT_WIN_OS_PX,
  POPUP_WIDTH_PX,
  POPUP_WIDTH_WIN_OS_ADD_PX,
} from '@/shared/popup'
import { useUIStore } from '@/popup/store/UIStore'

export const openInExternalPopup = async (
  router: Router,
  name: string
): Promise<void> => {
  const uiStore = useUIStore()
  if (
    !(uiStore.isFirefox || uiStore.isLinuxOs) ||
    process.env.EMBEDDED_WALLET
  ) {
    router.push({ name })
    return
  }

  const route = router.getRoutes().find(({ name: _name }) => name === _name)
  const addedWidth =
    uiStore.isWindowsOs || uiStore.isLinuxOs ? POPUP_WIDTH_WIN_OS_ADD_PX : 0
  const addedHeight =
    uiStore.isWindowsOs || uiStore.isLinuxOs
      ? POPUP_BAR_HEIGHT_WIN_OS_PX
      : POPUP_BAR_HEIGHT_PX

  await createPopup(
    `/popup.html?external#${route?.path ?? '/'}`,
    POPUP_WIDTH_PX + addedWidth,
    EXTENSION_HEIGHT_PX + addedHeight
  )
  window.close()
}
